// 🚀 쓰기(추가·수정·삭제) 함수를 한 겹 감싸서, 읽기 전용(모니터링) 계정이면 아예 실행되지 않게 한다.
// 각 업무 서비스가 firebase/firestore 대신 여기서 가져다 쓰면,
// 화면에서 버튼을 하나라도 빠뜨려도 데이터가 바뀌지 않는다(누락 방지).
// ※ 감사 로그(logService)는 읽기 전용 계정의 '로그인 기록'도 남겨야 하므로 여기를 쓰지 않는다.
import {
  addDoc as fsAddDoc,
  updateDoc as fsUpdateDoc,
  deleteDoc as fsDeleteDoc,
  setDoc as fsSetDoc
} from 'firebase/firestore';
import { assertCanEdit } from '../utils/permissions';

export const addDoc = (...args) => { assertCanEdit(); return fsAddDoc(...args); };
export const updateDoc = (...args) => { assertCanEdit(); return fsUpdateDoc(...args); };
export const deleteDoc = (...args) => { assertCanEdit(); return fsDeleteDoc(...args); };
export const setDoc = (...args) => { assertCanEdit(); return fsSetDoc(...args); };
